// ── Date formatting ────────────────────────────────────────────────────────
export function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr; // already formatted MM/DD/YYYY from API
  return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
}

export function fmtDateTime(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleString('en-US', {
    month: '2-digit', day: '2-digit', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  });
}

export function todayISO() {
  return new Date().toISOString().split('T')[0];
}

export function daysAgoISO(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().split('T')[0];
}

export function currentMonthRange() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const first = new Date(y, m, 1).toISOString().split('T')[0];
  const last  = new Date(y, m + 1, 0).toISOString().split('T')[0];
  return { from: first, to: last };
}

// ── Currency ───────────────────────────────────────────────────────────────
export function fmtCurrency(amount) {
  if (amount == null || amount === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

// ── Initials ───────────────────────────────────────────────────────────────
export function initials(name) {
  if (!name) return '??';
  return name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
}

// ── Status badge class ──────────────────────────────────────────────────────
export function statusClass(status) {
  const map = {
    Open: 'badge-open',
    Closed: 'badge-closed',
    Cancelled: 'badge-cancelled',
    Hold: 'badge-hold',
  };
  return map[status] || 'badge-open';
}

// ── File type icon label ────────────────────────────────────────────────────
export function fileExtIcon(ext) {
  const e = (ext || '').toLowerCase();
  if (e === 'pdf') return { cls: 'icon-pdf', lbl: 'PDF' };
  if (e === 'doc' || e === 'docx') return { cls: 'icon-doc', lbl: 'DOC' };
  if (e === 'xls' || e === 'xlsx') return { cls: 'icon-xls', lbl: 'XLS' };
  if (['jpg','jpeg','png','gif','webp'].includes(e)) return { cls: 'icon-img', lbl: 'IMG' };
  if (e === 'txt') return { cls: 'icon-txt', lbl: 'TXT' };
  return { cls: 'icon-def', lbl: (e.toUpperCase().slice(0, 3) || 'FIL') };
}

// ── Excel export ───────────────────────────────────────────────────────────
export function exportToExcel(data, filenameBase, sheetName) {
  return new Promise((resolve, reject) => {
    function doExport() {
      try {
        const XLSX = window.XLSX;
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);
        const colWidths = data[0].map((_, ci) => ({
          wch: Math.min(40, Math.max(10,
            data.reduce((max, row) => Math.max(max, row[ci] ? String(row[ci]).length : 0), 0) + 2
          )),
        }));
        ws['!cols'] = colWidths;
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        XLSX.writeFile(wb, `LoanDesk_${filenameBase}_${stamp}.xlsx`);
        resolve();
      } catch (e) { reject(e); }
    }

    if (window.XLSX) {
      doExport();
    } else {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = doExport;
      s.onerror = () => reject(new Error('Could not load Excel library'));
      document.head.appendChild(s);
    }
  });
}
